import { Route, Routes } from "react-router-dom";

import React from "react";
import QuestionView from "./QuestionView";
import QuestionCreate from "./QuestionCreate";
import QuestionsOverview from "./QuestionsOverview";

export const QuestionRoutes = () => {
  return (
    <Routes>
      <Route path="/view/:id" element={<QuestionView />} />
      <Route path="/create" element={<QuestionCreate />} />
      <Route path="/" element={<QuestionsOverview />} />
    </Routes>
  );
};
